<template>
  <div
    class="fs-the-navbar text-base bg-white sticky top-0 z-20 border-b border-new-gray-300 antialiased"
  >
    <div class="flex justify-between items-center py-2 h-14 px-4 xl:px-14">
      <!-- 左區 start-->
      <div class="flex items-center xl:justify-start xl:flex-1">
        <!-- Logo start-->
        <img
          src="@/assets/images/logo_web.svg"
          alt="fundswap-logo-image"
          class="w-[120px] sm:w-auto hover:cursor-pointer"
          @click="goWordPressIndex"
        />
        <!-- Logo end-->

        <!-- 主Nav start -->
        <nav class="hidden px-8 xl:flex">
          <a
            v-for="(nav, index) in navs"
            :key="'nav' + index"
            class="relative group text-new-gray-700 pr-6 py-4 last:pr-0 hover:text-new-primary-400 flex items-center whitespace-nowrap cursor-pointer"
          >
            <div class="font-medium">
              {{ nav.title }}
            </div>
            <div
              v-if="nav.suffix"
              class="text-sm transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
            >
              {{ nav.suffix }}
            </div>
            <div
              class="absolute top-[56px] -left-3 hidden bg-white whitespace-nowrap p-6 shadow z-50 group-hover:flex cursor-default"
            >
              <div
                v-for="(menu, index) in nav.menus"
                :key="'menu' + index"
                :class="[
                  'px-6 border-r border-new-gray-200 first:pl-0 last:pr-0 last:border-none',
                ]"
              >
                <a
                  v-if="menu.title"
                  :href="menu.link"
                  :target="menu.target"
                  :class="[
                    'text-new-gray-800 font-bold mb-4 inline-block',
                    menu.link ? 'hover:text-new-primary-400' : 'cursor-default',
                  ]"
                >
                  {{ menu.title }}
                </a>
                <div
                  :class="[
                    'grid gap-x-6 gap-y-4',
                    { 'grid-rows-4 grid-flow-col': menu.subMenus.length > 4 },
                  ]"
                >
                  <a
                    v-for="(subMenus, index) in menu.subMenus"
                    :key="'subMenus' + index"
                    :href="subMenus.link"
                    :target="subMenus.target"
                    :class="[
                      'text-sm text-new-gray-700 hover:text-new-primary-400 no-underline group',
                      { 'flex items-center': subMenus.iconName },
                    ]"
                  >
                    <div v-if="subMenus.iconName" class="w-5 mr-1">
                      <!-- 左方icon for 更多-->
                      <div v-if="subMenus.iconName === 'ellipsis-solid'">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="22"
                          width="22"
                          viewBox="0 0 512 512"
                          :class="[
                            'fill-new-gray-700 mr-1 group-hover:fill-new-primary-400',
                          ]"
                        >
                          <path
                            fill="currentColor"
                            d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                          />
                        </svg>
                      </div>

                      <!-- 左方icon for 其他-->
                      <img
                        v-else
                        :src="
                          require(`@/assets/images/${subMenus.iconName}.svg`)
                        "
                        :alt="subMenus.iconName"
                        class="w-full"
                      />
                    </div>

                    <div class="flex justify-start items-center">
                      <img
                        src="@/assets/images/devil.svg"
                        v-if="subMenus.icon"
                        class="mt-[1px] mr-2"
                        alt="devil"
                      />
                      <div :class="subMenus.textColor">
                        {{ subMenus.label }}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </a>
        </nav>
        <!-- 主Nav end -->

        <!-- 搜尋功能 start-->
        <div class="hidden xl:flex xl:flex-1 xl:max-w-[340px]">
          <slot></slot>
        </div>
        <!-- 搜尋功能 end-->
      </div>
      <!-- 左區 end-->

      <!-- 搜尋功能 start-->
      <div class="xl:hidden sm:ml-[-110px] flex-1 max-w-[340px]">
        <slot></slot>
      </div>
      <!-- 搜尋功能 end-->

      <!-- 右區 start-->
      <div>
        <!-- 副Nav start -->
        <nav class="hidden xl:flex">
          <a
            v-for="(subNav, index) in subNavs"
            :key="'subNav' + index"
            class="relative group text-new-gray-700 pr-6 py-4 first:ml-6 hover:text-new-primary-400 flex items-center whitespace-nowrap cursor-pointer"
          >
            <div
              v-if="subNav.title === '帳戶相關' && isLoggedIn"
              class="relative group"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 0C4.47581 0 0 4.47581 0 10C0 15.5242 4.47581 20 10 20C15.5242 20 20 15.5242 20 10C20 4.47581 15.5242 0 10 0ZM10 3.87097C11.9597 3.87097 13.5484 5.45968 13.5484 7.41935C13.5484 9.37903 11.9597 10.9677 10 10.9677C8.04032 10.9677 6.45161 9.37903 6.45161 7.41935C6.45161 5.45968 8.04032 3.87097 10 3.87097ZM10 17.7419C7.63306 17.7419 5.5121 16.6694 4.09274 14.9919C4.85081 13.5645 6.33468 12.5806 8.06452 12.5806C8.16129 12.5806 8.25806 12.5968 8.35081 12.625C8.875 12.7944 9.42339 12.9032 10 12.9032C10.5766 12.9032 11.129 12.7944 11.6492 12.625C11.7419 12.5968 11.8387 12.5806 11.9355 12.5806C13.6653 12.5806 15.1492 13.5645 15.9073 14.9919C14.4879 16.6694 12.3669 17.7419 10 17.7419Z"
                  fill="#333333"
                />
              </svg>
              <!-- 通知紅點 -->
              <div
                v-if="notificationCount > 0"
                class="absolute -top-1 left-3.5 h-4 min-w-[16px] w-fit rounded-full bg-new-red-500 text-white text-xs px-1 flex justify-center items-center group-hover:hidden"
              >
                {{ notificationCount }}
              </div>
              <!-- 通知紅點 -->
            </div>
            <template
              v-else-if="
                subNav.title === '限時優惠' || subNav.title === '基金庫存/紀錄'
              "
            >
              <div class="font-medium">{{ subNav.title }}</div>
              <div
                v-if="subNav.suffix"
                class="text-sm transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
              >
                {{ subNav.suffix }}
              </div>
            </template>
            <template v-else-if="isLoggedIn">
              <div class="font-medium">{{ subNav.title }}</div>
              <div
                v-if="subNav.suffix"
                class="text-sm font-normal transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
              >
                {{ subNav.suffix }}
              </div>
            </template>
            <div
              class="absolute top-[56px] right-0 hidden bg-white whitespace-nowrap p-6 shadow z-50 group-hover:flex cursor-default"
            >
              <div
                v-for="(menu, index) in subNav.menus"
                :key="'menu' + index"
                :class="[
                  'px-6 border-r border-new-gray-200 first:pl-0 last:pr-0 last:border-none',
                ]"
              >
                <a
                  v-if="menu.title"
                  :href="menu.link"
                  :class="[
                    'text-new-gray-800 font-bold mb-4 inline-block',
                    menu.link ? 'hover:text-new-primary-400' : 'cursor-default',
                  ]"
                >
                  {{ menu.title }}
                </a>
                <div
                  :class="[
                    'grid gap-x-6 gap-y-4',
                    { 'grid-rows-4 grid-flow-col': menu.subMenus.length > 4 },
                  ]"
                >
                  <a
                    v-for="(subMenus, index) in menu.subMenus"
                    :key="'subMenus' + index"
                    :href="
                      subMenus.isHtml && !subMenus.link
                        ? 'javascript:void(0)'
                        : subMenus.link
                    "
                    :target="subMenus.target"
                    :class="[
                      'text-sm text-new-gray-700 hover:text-new-primary-400 no-underline group',
                      {
                        'flex items-center':
                          subMenus.iconName || notificationCount > 0,
                      },
                    ]"
                    @click="subMenus.isHtml ? openForeignAlert() : ''"
                  >
                    <div v-if="subMenus.isHtml">
                      <div v-html="subMenus.label"></div>
                    </div>
                    <template v-else>
                      <!-- 左方icon for 更多-->
                      <div
                        v-if="
                          subMenus.iconName &&
                          subMenus.iconName === 'ellipsis-solid'
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="22"
                          width="22"
                          viewBox="0 0 512 512"
                          :class="[
                            'fill-new-gray-700 mr-1 group-hover:fill-new-primary-400',
                          ]"
                        >
                          <path
                            fill="currentColor"
                            d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                          />
                        </svg>
                      </div>

                      <!-- 左方icon for 其他-->
                      <img
                        v-if="
                          subMenus.iconName &&
                          subMenus.iconName !== 'ellipsis-solid'
                        "
                        :src="
                          require(`@/assets/images/${subMenus.iconName}.svg`)
                        "
                        :alt="subMenus.iconName"
                        class="mr-1"
                      />

                      <span :class="subMenus.textColor">{{
                        subMenus.label
                      }}</span>
                      <!-- 通知紅點 -->
                      <span
                        v-if="
                          subMenus.label === '通知中心' && notificationCount > 0
                        "
                        class="h-4 min-w-[16px] w-fit rounded-full bg-new-red-500 text-white text-xs px-1 ml-1 flex justify-center items-center"
                      >
                        {{ notificationCount }}
                      </span>
                      <!-- 通知紅點 -->
                    </template>
                  </a>
                </div>
              </div>
            </div>
          </a>
          <!-- 導頁Buttons start-->
          <div class="flex justify-center items-center">
            <button
              v-if="isLoggedIn"
              class="bg-white text-new-gray-800 font-medium ring-1 ring-new-gray-300 px-4 py-2 rounded whitespace-nowrap hover:cursor-pointer focus:outline-none"
              @click="toLogout"
            >
              登出
            </button>
            <button
              v-if="!isLoggedIn"
              class="bg-white text-new-gray-800 font-medium border border-new-gray-300 px-4 py-2 rounded mr-2 focus:outline-none"
              @click="toLoginPage"
            >
              登入
            </button>
            <button
              v-if="!isLoggedIn"
              class="text-white font-medium bg-new-primary-500 px-4 py-2 rounded focus:outline-none hover:cursor-pointer"
              @click="toRegisterPage"
            >
              開戶
            </button>
          </div>
          <!-- 導頁Buttons end-->
        </nav>
        <!-- 副Nav end -->

        <!-- 漢堡按鈕 start-->
        <button
          class="relative xl:hidden bg-white w-5 h-9 focus:outline-none"
          @click="isOpenMenu = !isOpenMenu"
        >
          <div
            class="block w-5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
          >
            <span
              aria-hidden="true"
              class="block absolute h-[3px] w-5 bg-new-gray-700 transform transition duration-500 ease-in-out rounded-[1px]"
              :class="{
                'rotate-45': isOpenMenu,
                'translate-y-[-0.4rem]': !isOpenMenu,
              }"
            ></span>
            <span
              aria-hidden="true"
              class="block absolute h-[3px] w-5 bg-new-gray-700 transform transition duration-500 ease-in-out rounded-[1px]"
              :class="{ 'opacity-0': isOpenMenu }"
            ></span>
            <span
              aria-hidden="true"
              class="block absolute h-[3px] w-5 bg-new-gray-700 transform transition duration-500 ease-in-out rounded-[1px]"
              :class="{
                '-rotate-45': isOpenMenu,
                'translate-y-[0.4rem]': !isOpenMenu,
              }"
            ></span>
          </div>
          <!-- 通知紅點 -->
          <div
            v-if="notificationCount > 0"
            class="absolute top-0 left-3 h-4 min-w-[16px] w-fit rounded-full bg-new-red-500 text-white text-xs px-1 flex justify-center items-center group-hover:hidden"
          >
            {{ notificationCount }}
          </div>
          <!-- 通知紅點 -->
        </button>
        <!-- 漢堡按鈕 end-->
      </div>
      <!-- 右區 end-->
    </div>

    <!-- Mobile Navs Model start -->
    <div v-if="isOpenMenu" class="fixed top-0 left-0 xl:hidden">
      <div
        v-if="isOpenMenu"
        :class="[
          'w-full h-full fixed z-50 flex justify-end bg-black bg-opacity-70',
        ]"
        @click.self="isOpenMenu = false"
      ></div>
      <div
        :class="[
          'bg-white h-full w-80 transition-all duration-300 fixed z-50 overflow-auto',
          isOpenMenu ? 'right-0' : '-right-80',
        ]"
      >
        <div
          class="flex justify-end items-center px-4 py-2.5 border-b bg-white sticky top-0 z-50"
        >
          <button
            v-if="isLoggedIn"
            class="bg-white text-new-gray-800 font-medium ring-1 ring-new-gray-300 px-4 py-[7px] rounded mr-4 hover:cursor-pointer focus:outline-none"
            @click="toLogout"
          >
            登出
          </button>
          <button
            v-if="!isLoggedIn"
            class="bg-white text-new-gray-800 font-medium ring-1 ring-new-gray-300 px-4 py-[7px] rounded mr-4 hover:cursor-pointer focus:outline-none"
            @click="toLoginPage"
          >
            登入
          </button>
          <button
            v-if="!isLoggedIn"
            class="text-white font-medium bg-new-primary-500 px-4 py-2 rounded mr-4 focus:outline-none"
            @click="toRegisterPage"
          >
            開戶
          </button>
          <button
            class="relative xl:hidden bg-white w-5 h-9 focus:outline-none"
            @click="(isOpenMenu = !isOpenMenu), (isShowContent = false)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M13.7909 10L19.4767 4.3142C20.1744 3.61648 20.1744 2.48523 19.4767 1.78693L18.2131 0.523295C17.5153 -0.174432 16.3841 -0.174432 15.6858 0.523295L10 6.20909L4.3142 0.523295C3.61648 -0.174432 2.48523 -0.174432 1.78693 0.523295L0.523295 1.78693C-0.174432 2.48466 -0.174432 3.61591 0.523295 4.3142L6.20909 10L0.523295 15.6858C-0.174432 16.3835 -0.174432 17.5148 0.523295 18.2131L1.78693 19.4767C2.48466 20.1744 3.61648 20.1744 4.3142 19.4767L10 13.7909L15.6858 19.4767C16.3835 20.1744 17.5153 20.1744 18.2131 19.4767L19.4767 18.2131C20.1744 17.5153 20.1744 16.3841 19.4767 15.6858L13.7909 10Z"
                fill="#666666"
              />
            </svg>
          </button>
        </div>

        <nav class="flex flex-col">
          <a
            v-for="(navs, idx) in mobileNavs"
            :key="'mobileNavs' + idx"
            @click="toggle(idx)"
          >
            <div
              class="flex justify-between items-center text-new-gray-800 font-medium p-4"
            >
              <div
                :class="[
                  'flex items-center leading-none',
                  {
                    'text-new-primary-600':
                      currentMenuIndex === idx && isShowContent,
                  },
                ]"
              >
                {{ navs.title === "帳戶相關" ? "會員/基金追蹤" : navs.title }}
                <div
                  v-if="navs.suffix"
                  class="text-sm font-normal transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
                >
                  {{ navs.suffix }}
                </div>
                <!-- 通知紅點 -->
                <div
                  v-if="
                    navs.title === '帳戶相關' &&
                    !(currentMenuIndex === idx && isShowContent) &&
                    notificationCount > 0
                  "
                  class="h-4 min-w-[16px] w-fit rounded-full bg-new-red-500 text-white text-xs px-1 ml-2 flex justify-center items-center group-hover:hidden"
                >
                  {{ notificationCount }}
                </div>
                <!-- 通知紅點 -->
              </div>

              <svg
                v-if="currentMenuIndex === idx && isShowContent"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
              >
                <path
                  d="M7.51832 1.16969L13.4522 7.10356C13.7384 7.38974 13.7384 7.85372 13.4522 8.13988L12.7601 8.83197C12.4744 9.11767 12.0114 9.11821 11.725 8.83319L7.00015 4.1305L2.27532 8.83322C1.98896 9.11825 1.52592 9.1177 1.24023 8.832L0.548135 8.13991C0.26195 7.85372 0.26195 7.38974 0.548135 7.10359L6.482 1.16972C6.76816 0.883535 7.23214 0.883536 7.51832 1.16969Z"
                  :fill="
                    currentMenuIndex === idx && isShowContent
                      ? '#FF7E40'
                      : '#333333'
                  "
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
              >
                <path
                  d="M6.482 8.83202L0.548135 2.89812C0.26195 2.61193 0.26195 2.14796 0.548135 1.8618L1.24023 1.16971C1.52592 0.884013 1.98896 0.883463 2.27532 1.16849L7.00018 5.87121L11.725 1.16849C12.0114 0.883463 12.4744 0.884013 12.7601 1.16971L13.4522 1.8618C13.7384 2.14799 13.7384 2.61197 13.4522 2.89812L7.51835 8.83202C7.23217 9.11817 6.76819 9.11817 6.482 8.83202Z"
                  fill="#333333"
                />
              </svg>
            </div>
            <div
              class="relative overflow-hidden transition-all max-h-0 duration-150 bg-new-gray-200"
              :style="`max-height:${
                currentMenuIndex === idx && isShowContent
                  ? $refs.content[idx].scrollHeight
                  : 0
              }px`"
              ref="content"
            >
              <div
                v-for="(menu, indx) in navs.menus"
                :key="'mobileMenu' + indx"
                :class="['px-4 py-2', { 'first:pt-4': menu.title }]"
              >
                <a
                  v-if="menu.title"
                  :href="!menu.link ? 'javascript:void(0)' : menu.link"
                  :class="[
                    'text-new-gray-800 font-bold inline-block',
                    menu.link ? 'hover:text-new-primary-400' : 'cursor-default',
                  ]"
                  @click="!menu.link ? '' : closeMenu"
                >
                  {{ menu.title }}
                </a>
                <div
                  :class="[
                    'text-sm grid gap-4 my-2',
                    { 'grid-rows-4 grid-flow-col': menu.subMenus.length > 4 },
                  ]"
                >
                  <a
                    v-for="(subMenus, id) in menu.subMenus"
                    :key="'mobileSubMenus' + id"
                    class="whitespace-nowrap flex"
                    :href="
                      subMenus.isHtml && !subMenus.link
                        ? 'javascript:void(0)'
                        : subMenus.link
                    "
                    :target="subMenus.target"
                    @click="
                      subMenus.isHtml ? openForeignAlert(idx) : closeMenu()
                    "
                  >
                    <div v-if="subMenus.isHtml">
                      <div v-html="subMenus.label"></div>
                    </div>
                    <div
                      v-else
                      :class="[
                        'text-new-gray-700 hover:text-new-primary-400 flex items-center',
                        { 'px-4': id < 4 && menu.title },
                        subMenus.textColor,
                      ]"
                    >
                      <div
                        v-if="
                          subMenus.iconName &&
                          subMenus.iconName === 'ellipsis-solid'
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="22"
                          width="22"
                          viewBox="0 0 512 512"
                          :class="[
                            'fill-new-gray-700 mr-1 group-hover:fill-new-primary-400',
                          ]"
                        >
                          <path
                            fill="currentColor"
                            d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                          />
                        </svg>
                      </div>

                      <img
                        v-if="
                          subMenus.iconName &&
                          subMenus.iconName !== 'ellipsis-solid'
                        "
                        :src="
                          require(`@/assets/images/${subMenus.iconName}.svg`)
                        "
                        :alt="subMenus.iconName"
                        class="mr-1"
                      />

                      <div class="flex justify-start items-center">
                        <img
                          src="@/assets/images/devil.svg"
                          v-if="subMenus.icon"
                          class="mr-2"
                          alt="devil"
                        />
                        {{ subMenus.label }}
                      </div>
                      <div
                        v-if="subMenus.suffix"
                        class="text-sm transform scale-[0.8] text-white bg-new-red-500 leading-none rounded px-1 py-0.5"
                      >
                        {{ subMenus.suffix }}
                      </div>
                      <!-- 通知紅點 -->
                      <div
                        v-if="subMenus.label === '通知中心'"
                        class="h-4 min-w-[16px] w-fit rounded-full bg-new-red-500 text-white text-xs px-1 ml-2 flex justify-center items-center group-hover:hidden"
                      >
                        {{ notificationCount }}
                      </div>
                      <!-- 通知紅點 -->
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </a>
        </nav>
        <!-- Mobile Navs Model end -->
      </div>
    </div>
    <transaction-failed-notification
      v-if="isLoggedIn"
    ></transaction-failed-notification>

    <alert-modal v-model="isShowForeignAlert">
      <div class="text-new-gray-800 text-lg font-bold my-4">
        <div>[外幣開戶]</div>
        <div>補件通知</div>
      </div>

      <div class="w-14 h-14 mx-auto my-4">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="#FFD4C0"
            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
          />
        </svg>
      </div>

      <div class="text-sm text-new-gray-700 my-4">
        <div>因您的證件有變更，請補件：</div>
        <div>更新存摺、身份證</div>
      </div>

      <div class="flex gap-2">
        <button
          class="bg-white border text-new-gray-800 text-lg font-bold w-full p-2 rounded"
          @click="isShowForeignAlert = false"
        >
          取消
        </button>

        <button
          class="bg-new-primary-500 text-lg text-white font-bold w-full p-2 rounded"
          @click="toForeignApplyPage"
        >
          進行補件
        </button>
      </div>
    </alert-modal>

    <alert-modal v-model="isShowForeignSubmittedAlert">
      <div class="text-new-gray-800 text-lg font-bold my-4">
        <div>[外幣開戶]</div>
        <div>正在審核中</div>
      </div>

      <div class="w-14 h-14 mx-auto my-4">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="#FFD4C0"
            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
          />
        </svg>
      </div>

      <div class="text-sm text-new-gray-700 my-4">
        開啟後，將會 Email 通知您
      </div>

      <button
        class="bg-new-primary-500 text-lg text-white font-bold w-full p-2 rounded"
        @click="isShowForeignSubmittedAlert = false"
      >
        我知道了
      </button>
    </alert-modal>
  </div>
</template>

<script>
import TransactionFailedNotification from "./FailedNotification.vue";
import AlertModal from "./AlertModal.vue";

export default {
  name: "TheNavbar",
  props: {
    apiBaseUrl: {
      type: String,
      default: () => "/trade/api",
    },
  },
  components: {
    TransactionFailedNotification,
    AlertModal,
  },
  data() {
    return {
      isOpenMenu: false,
      navs: [
        {
          title: "市場精選",
          menus: [
            {
              title: "投資資訊統計",
              link: "/trade/",
              subMenus: [
                {
                  label: "ETF 專區",
                  link: "/trade?parent=excellent&ref=ETF",
                },
                {
                  label: "買好股",
                  link: "/trade?parent=excellent&ref=stock",
                },
                {
                  label: "選好債",
                  link: "/trade?parent=excellent&ref=bond",
                },
                {
                  label: "基金品牌",
                  link: "/trade?parent=fundBrand&ref=brand",
                },
                {
                  label: "國人持有",
                  link: "/trade?parent=ranking&ref=top",
                },
                {
                  label: "獲獎基金",
                  link: "/trade?parent=ranking&ref=excellent",
                },
                {
                  label: "全球布局",
                  link: "/trade?parent=parentGlobal&ref=global",
                },
                {
                  label: "產業動態",
                  link: "/trade?parent=parentIndustry&ref=industry",
                },
              ],
            },
          ],
        },
        {
          title: "找基金",
          menus: [
            {
              title: "基金搜尋",
              link: "/trade/funds/",
              subMenus: [
                {
                  label: "基金總覽",
                  link: "/trade/funds/",
                },
                {
                  label: "配息專區",
                  link: "/trade/funds/?filterType=dividend&tradable=true&s=-dividendAnnualRateOfReturn&page=1&dividendFrequency=半年配息|季配息|年配息|月配息|未固定配息",
                },
                {
                  label: "持股選基金",
                  link: "/trade/funds/?fundsIndex=0",
                },
                {
                  label: "基金照妖鏡",
                  link: "/trade/funds/?fundsIndex=2&filterType=rateOfReturn&tradable=true&s=-rateOfReturn3Months&page=1",
                  icon: "devil",
                },
              ],
            },
            {
              title: "本土投信",
              link: "/trade/funds/?filterType=rateOfReturn&tradable=true&page=1&fundArea=境內",
              subMenus: [
                {
                  label: "野村投信",
                  link: "/fund-brand/Nomura/",
                },
                {
                  label: "國泰投信",
                  link: "/fund-brand/Cathay/",
                },
                {
                  label: "兆豐投信",
                  link: "/fund-brand/MegaBank/",
                },
                {
                  label: "瀚亞投信",
                  link: "/fund-brand/eastspring/",
                },
                {
                  label: "統一投信",
                  link: "/fund-brand/ezmoney/",
                },
                {
                  label: "群益投信",
                  link: "/fund-brand/Capital/",
                },
                {
                  label: "復華投信",
                  link: "/fund-brand/FHTrust/",
                },
                {
                  label: "......更多",
                  link: "/fund-brand/",
                },
              ],
            },
            {
              title: "國外品牌",
              link: "/trade/funds/?filterType=rateOfReturn&tradable=true&page=1&fundArea=境外",
              subMenus: [
                {
                  label: "貝萊德 BlackRock",
                  link: "/fund-brand/BlackRock/",
                },
                {
                  label: "安聯投信",
                  link: "/fund-brand/Allianz/",
                },
                {
                  label: "摩根 J.P. Morgan",
                  link: "/fund-brand/JPMorgan/",
                },
                {
                  label: "高盛(原NNL) GS",
                  link: "/fund-brand/GoldmanSachs/",
                },
                {
                  label: "富達 Fidelity",
                  link: "/fund-brand/Fidelity/",
                },
                {
                  label: "景順 Invesco",
                  link: "/fund-brand/Invesco/",
                },
                {
                  label: "施羅德 Schroders ",
                  link: "/fund-brand/Schroders/",
                },
                {
                  label: "......更多",
                  link: "/fund-brand/",
                },
              ],
            },
          ],
        },
        {
          title: "教學/FAQ",
          menus: [
            {
              title: "服務介紹",
              link: "https://www.fundswap.com.tw/posts-index/categories/fund-services/",
              target: "_self",
              subMenus: [
                {
                  label: "5 分鐘線上開戶",
                  link: "https://fundswap.01.firstline.cc/article/92",
                  target: "_self",
                },
                {
                  label: "綁定台幣扣款",
                  link: "https://fundswap.01.firstline.cc/sub-category/5/article",
                  target: "_self",
                },
                {
                  label: "手機桌面 APP 圖示",
                  link: "https://fundswap.01.firstline.cc/sub-category/19/article",
                  target: "_self",
                },
                {
                  label: "電支雞懶人包",
                  link: "/posts-index/fund-news/pxfund-tutorial/",
                },
              ],
            },
            {
              title: "常見問題",
              link: "https://fundswap.01.firstline.cc/helpdesk",
              subMenus: [
                {
                  label: "單筆申購、贖回",
                  link: "https://fundswap.01.firstline.cc/sub-category/1/article",
                  target: "_self",
                },
                {
                  label: "定期定額投資",
                  link: "https://fundswap.01.firstline.cc/sub-category/2/article",
                  target: "_self",
                },
                {
                  label: "基金交換特色",
                  link: "https://fundswap.01.firstline.cc/sub-category/27/article",
                  target: "_self",
                },
                {
                  label: "牌告收費標準",
                  link: "https://fundswap.01.firstline.cc/article/96",
                  target: "_self",
                },
                {
                  label: "開戶補件",
                  link: "https://fundswap.01.firstline.cc/article/18",
                  target: "_self",
                },
                {
                  label: "開啟外幣功能",
                  link: "https://fundswap.01.firstline.cc/article/6",
                  target: "_self",
                },
                {
                  label: "電支雞扣款儲值",
                  link: "https://fundswap.01.firstline.cc/article/106",
                  target: "_self",
                },
                {
                  label: "......更多",
                  link: "https://fundswap.01.firstline.cc/helpdesk",
                  target: "_self",
                },
              ],
            },
          ],
        },
        {
          title: "投資分析",
          menus: [
            {
              title: "文章總覽",
              link: "/posts-index/",
              subMenus: [
                {
                  label: "服務介紹",
                  link: "/posts-index/categories/fund-services/",
                },
                {
                  label: "市場情報",
                  link: "/posts-index/categories/fund-news/",
                },
                {
                  label: "投信觀點",
                  link: "/posts-index/categories/fund-house-view/",
                },
                {
                  label: "基金知識",
                  link: "/posts-index/categories/fund-knowledge/",
                },
              ],
            },
            {
              title: "焦點強棒",
              link: "/trade/funds/?filterType=rateOfReturn&tradable=true&majorFund=true&s=-rateOfReturn3Months&page=1&series=滙豐%7C野村%7C貝萊德%7C安聯投信%7C景順%7C摩根%7C富達%7C中國信託%7C台中銀%7C先機%7C法盛%7C施羅德%7C晉達%7C紐約梅隆%7C高盛%28原NNL%29%7C瑞聯%7C駿利亨德森%7C聯邦%7C華南永昌%7CGAM%7C新加坡大華%7C宏利%7C路博邁&investmentTarget=債券型%7C股票型&currency=美元&fundScale=3000.0&dividendFrequency=不配息&riskLevel=3%7C4%7C5",
              subMenus: [
                {
                  label: "基金怎麼選？",
                  link: "/posts-index/fund-knowledge/teaching20250211/",
                },
                {
                  label: "基金怎麼買？",
                  link: "/posts-index/fund-knowledge/how-mutual-fund/",
                },
                {
                  label: "揭開ETF的秘密",
                  link: "/posts-index/fund-knowledge/etf20250113/",
                },
                {
                  label: "掌握降息契機",
                  link: "/posts-index/fund-knowledge/interestrates20240916/",
                },
              ],
            },
          ],
        },
        {
          title: "客戶服務",
          menus: [
            {
              title: "關於我們",
              link: "/aboutfundswap/",
              subMenus: [
                {
                  label: "認識好好",
                  link: "/aboutfundswap/",
                },
                {
                  label: "公告訊息",
                  link: "/trade/announcements/",
                },
                {
                  label: "聯絡客服",
                  link: "https://fundswap.01.firstline.cc/article/91",
                  target: "_self",
                  iconName: "comments-solid",
                  textColor: "text-new-primary-500",
                },
              ],
            },
          ],
        },
      ],
      isShowContent: false,
      currentMenuIndex: 0,
      isTenantLoggedIn: false,
      notificationCount: 0,
      condition: true,
      tenantStatus: null,
      isShowForeignAlert: false,
      isShowForeignSubmittedAlert: false,
    };
  },
  computed: {
    isFundswapTrade() {
      return window.location.href && window.location.href.includes("/trade");
    },
    isLoggedIn() {
      return this.isFundswapTrade
        ? this.$auth && this.$auth.loggedIn
        : this.isTenantLoggedIn;
    },
    subNavs() {
      let navs = [
        {
          title: "限時優惠",
          menus: [
            {
              title: "最新活動",
              link: "/campaign/",
              subMenus: [
                {
                  label: "這 mo 好康",
                  link: "/campaign/campaign-double-gift-account/?coupon-fs888",
                  target: "_self",
                },
                {
                  label: "電支雞任務卡",
                  link: "/campaign/pxfund-3/",
                  target: "_self",
                },
                {
                  label: "一「定」免費",
                  link: "/campaign/sip-0-fee",
                  target: "_self",
                },
                {
                  label: "......更多",
                  link: "/campaign/",
                  target: "_self",
                },
              ],
            },
          ],
          suffix: "hot",
        },
        {
          title: "基金庫存/紀錄",
          menus: [
            {
              title: "基金庫存",
              link: "/trade/inventory/funds/",
              subMenus: [
                {
                  label: "我的基金",
                  link: "/trade/inventory/funds/",
                },
                {
                  label: "現金(出/入金)",
                  link: "/trade/member-center/ledger/",
                },
                {
                  label: "月對帳單",
                  link: "/trade/member-center/statements/",
                },
              ],
            },
            {
              title: "交易紀錄",
              link: "/trade/transactions/",
              subMenus: [
                {
                  label: "交易委託中",
                  link: "/trade/transactions/?status=pending,canceled",
                },
                {
                  label: "定期定額契約",
                  link: "/trade/transactions/sip/",
                },
                {
                  label: "基金比較",
                  link: "/trade/funds-compare/?mfxID=ARBB,JP64,FD56,IVB5,LAAO",
                  iconName: "plus-solid",
                  textColor: "text-new-primary-500",
                },
              ],
            },
          ],
        },
      ];

      let tenantSubnavs = [
        {
          title: "帳戶相關",
          menus: [
            {
              title: "我的",
              subMenus: [
                {
                  label: "會員中心",
                  link: "/trade/member-center/",
                },
                ...(this.tenantStatus &&
                this.tenantStatus.openingStatus === "passed"
                  ? [
                      {
                        label: "修改風險屬性",
                        link: "/trade/member-center/risk-level-questionnaire/",
                      },
                    ]
                  : []),
                ...(this.isApplyForeignAccountAvailable
                  ? [
                      {
                        label: `<div class="fs-foreign-manu-nav-link">開啟外幣功能${this.foreignAccountStatusDesc}</div>`,
                        link: this.isForeignAccountStatusNotApplied
                          ? "/trade/member-center/apply-foreign-account/"
                          : "",
                        isHtml: true,
                      },
                    ]
                  : []),
                ...(this.isAccountOpening
                  ? [
                      {
                        label: "開戶進度/線上補件",
                        link:
                          (this.tenantStatus &&
                            this.tenantStatus.openingStatus ===
                              "not-applied") ||
                          (this.tenantStatus &&
                            this.tenantStatus.openingStatus ===
                              "account-opening")
                            ? "/trade/member-center/open-account/"
                            : `/trade${
                                this.tenantStatus &&
                                this.tenantStatus.accountOpenLink
                              }`,
                        iconName: "address-card-solid",
                        textColor: "text-new-primary-500",
                      },
                    ]
                  : []),
              ],
            },
            {
              title: "設定",
              link: "/trade/member-center/",
              subMenus: [
                {
                  label: "我的追蹤",
                  link: "/trade/tracking-list/",
                },
                {
                  label: "變更密碼",
                  link: "/trade/member-center/change-password/",
                },
                {
                  label: "快速驗證",
                  link: "/trade/member-center/webauthn-devices/",
                },
              ],
            },
          ],
        },
      ];

      return this.isLoggedIn ? [...navs, ...tenantSubnavs] : navs;
    },
    mobileNavs() {
      let subNavs = this.subNavs.filter((navs) =>
        this.isLoggedIn
          ? navs
          : navs.title === "限時優惠" || navs.title === "基金庫存/紀錄"
      );
      return [...subNavs, ...this.navs];
    },
    isAccountOpening() {
      return [
        "not-applied",
        "account-opening",
        "reservation-secondary-auth-needed",
        "additional-doc-needed",
        "secondary-reauth-needed",
        "primary-reauth-needed",
        "both-reauth-needed",
        "personal-info-error",
        "deduction-needed",
      ].includes(this.tenantStatus && this.tenantStatus.openingStatus);
    },
    isApplyForeignAccountAvailable() {
      return (
        this.tenantStatus &&
        this.tenantStatus.status === "opened" &&
        this.tenantStatus.hasAuthorizedDeduction &&
        this.tenantStatus.hasAuthorizedDeduction.primaryMarket &&
        this.tenantStatus.foreignCurrencyStatus !== "done" &&
        this.tenantStatus.openingStatus === "passed" &&
        !this.tenantStatus.isMustDoPrimaryDeductionAuth
      );
    },
    isForeignAccountStatusNotApplied() {
      let status = this.tenantStatus && this.tenantStatus.foreignCurrencyStatus;
      return (
        status === "not-applied" ||
        status === "reject" ||
        status === "fail" ||
        status === "expired" ||
        status === "cancel"
      );
    },
    isForeignAccountStatusAdditionalDocNeeded() {
      let status = this.tenantStatus && this.tenantStatus.foreignCurrencyStatus;
      return status === "additional-doc-needed";
    },
    isForeignAccountStatusSubmitted() {
      let status = this.tenantStatus && this.tenantStatus.foreignCurrencyStatus;
      return (
        status === "request" ||
        status === "request-call-out" ||
        status === "prepare-send-tdcc" ||
        status === "send-tdcc-debit-authorization" ||
        status === "received-tdcc" ||
        status === "send-tdcc-customer" ||
        status === "send-tdcc"
      );
    },
    foreignAccountStatusDesc() {
      return this.isForeignAccountStatusNotApplied
        ? '<span class="fs-foreign-not-applied">尚未開通</span>'
        : this.isForeignAccountStatusAdditionalDocNeeded
        ? '<div class="fs-foreign-additional-doc-needed"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16"><path fill="#FA3130" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg></svg>待補件</div>'
        : '<div class="fs-foreign-submitted"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16"><path fill="#999999" d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>審核中</div>';
    },
  },
  watch: {
    isOpenMenu: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.isLoggedIn
              ? (this.currentMenuIndex = 3)
              : (this.currentMenuIndex = 2);
            this.isShowContent = true;
            this.$emit("toggle-mobile-menu", true);
            document.querySelector("html").classList.add("fixed-bg-modal");
          });
        } else {
          document.querySelector("html").classList.remove("fixed-bg-modal");
          this.isShowContent = false;
        }
      },
    },
    isFundswapTrade: {
      handler() {
        this.fetchTenantStatus();
      },
    },
    isLoggedIn: {
      immediate: true,
      handler() {
        this.fetchTenantStatus();
        // this.fetchNoticeCount();
      },
    },
  },
  methods: {
    async toLogout() {
      if (this.isFundswapTrade) {
        await this.$auth.logout();
      } else {
        await fetch(`${this.apiBaseUrl}/sign-out`, {
          method: "POST",
          credentials: "include",
        });
      }
      this.fetchTenantStatus();
      this.closeMenu();
    },
    toLoginPage() {
      if (this.isFundswapTrade) {
        this.$router.push({ name: "login" });
      } else {
        window.location = "/trade/login";
        history.pushState({}, "", "/trade/login");
      }
      this.closeMenu();
    },
    toRegisterPage() {
      if (this.isFundswapTrade) {
        this.$router.push({ name: "signup" });
      } else {
        window.location = "/trade/signup";
        history.pushState({}, "", "/trade/signup");
      }
      this.closeMenu();
    },
    toggle(idx) {
      if (this.currentMenuIndex === idx) {
        this.isShowContent = !this.isShowContent;
      } else {
        this.isShowContent = true;
      }
      this.currentMenuIndex = idx;
    },
    async fetchTenantStatus() {
      if (this.isFundswapTrade) {
        this.$auth && this.$auth.fetchUser({ noRedirect: true });
        this.tenantStatus =
          this.$auth && this.$auth.loggedIn && this.$auth.user;
      } else {
        const response = await fetch(`${this.apiBaseUrl}/tenant/status`, {
          credentials: "include",
        });
        if (response.status === 200) {
          this.isTenantLoggedIn = true;
          const data = await response.json();
          this.tenantStatus = data.data;
        } else {
          this.isTenantLoggedIn = false;
        }
      }
    },
    closeMenu() {
      this.isOpenMenu = false;
      this.isShowContent = false;
      document.querySelector("html").classList.remove("fixed-bg-modal");
    },
    goWordPressIndex() {
      window.location = window.origin;
    },
    async fetchNoticeCount() {
      if (this.isFundswapTrade) {
        this.$HowHowApi.noticeCount().then((response) => {
          let data = response.data && response.data.data;
          if (!data) return;
          this.notificationCount =
            data.personalNotificationCount + data.systemNotificationCount;
        });
      } else {
        const response = await fetch(
          `${this.apiBaseUrl}/tenant/notification/count`,
          { credentials: "include" }
        );
        if (response.status === 200) {
          const data = await response.json();
          this.notificationCount =
            data.data &&
            data.data.personalNotificationCount +
              data.data.systemNotificationCount;
        } else {
          this.notificationCount = 0;
        }
      }
    },
    openForeignAlert(index) {
      if (index) this.toggle(index);

      if (this.isForeignAccountStatusAdditionalDocNeeded) {
        this.isShowForeignAlert = true;
      }
      if (this.isForeignAccountStatusSubmitted) {
        this.isShowForeignSubmittedAlert = true;
      }
    },
    toForeignApplyPage() {
      this.isShowForeignAlert = false;
      this.closeMenu();

      if (this.isFundswapTrade) {
        this.$router.push({ name: "member-center-apply-foreign-account" });
      } else {
        window.location = "/trade/member-center/apply-foreign-account";
        history.pushState({}, "", "/trade/member-center/apply-foreign-account");
      }
    },
  },
  mounted() {
    this.fetchTenantStatus();

    window.addEventListener("resize", this.closeMenu);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.closeMenu);
  },
};
</script>

<style>
.fixed-bg-modal {
  height: 100%;
  overflow: hidden !important;
}
.fs-foreign-manu-nav-link {
  color: #666666; /* Tailwind's text-new-gray-700 */
  margin-left: 1rem; /* Tailwind's ml-4 */
  display: flex; /* Tailwind's flex */
  align-items: center; /* Tailwind's items-center */
}

.fs-foreign-manu-nav-link:hover {
  color: #ffab83; /* Tailwind's hover:text-new-primary-400 */
}

@media (min-width: 1280px) {
  /* Tailwind's xl:ml-0 */
  .fs-foreign-manu-nav-link {
    margin-left: 0;
  }
}

.fs-foreign-not-applied {
  color: #fa3130; /* Tailwind's text-new-red-500 */
  margin-left: 0.5rem; /* Tailwind's ml-2 */
}

.fs-foreign-additional-doc-needed {
  color: #fa3130; /* Tailwind's text-new-red-500 */
  display: inline-flex; /* Tailwind's inline-flex */
  justify-content: space-between; /* Tailwind's justify-between */
  align-items: center; /* Tailwind's items-center */
  margin-left: 0.5rem; /* Tailwind's ml-2 */
  width: 4rem; /* Tailwind's w-16 */
}

.fs-foreign-submitted {
  color: #999999; /* Tailwind's text-new-gray-600 */
  display: inline-flex; /* Tailwind's inline-flex */
  justify-content: space-between; /* Tailwind's justify-between */
  align-items: center; /* Tailwind's items-center */
  margin-left: 0.5rem; /* Tailwind's ml-2 */
  width: 4rem; /* Tailwind's w-16 */
}
</style>

<style lang="scss" scoped>
@use "tailwindcss/base" as base;
@use "tailwindcss/components" as components;
@use "tailwindcss/utilities" as utilities;

@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700&display=swap");

:root {
  --condition: #{isFundswapTrade};
}

@if not var(--condition) {
  base components utilities * {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: #f5f5f5;
  }
}

.fs-the-navbar {
  font-family: "Noto Sans TC", Microsoft JhengHei, 微軟正黑體;
}
</style>
